module.exports = __webpack_public_path__ + "mm.svg?a646bac36c08c5b843f8eb9efa0ddd88";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mm.svg
// module id = 1245
// module chunks = 0